import immutable from 'seamless-immutable';
import { createReducer, completeReducer, completeState } from 'redux-recompose';

import { actions } from './actions';

const defaultState = completeState({
  refundTransaction: null
});

const reducerDescription = {
  primaryActions: [actions.REFUND_TRANSACTION]
};

const reducer = createReducer(immutable(defaultState), completeReducer(reducerDescription));
export default reducer;
